module.exports = __webpack_public_path__ + "img/李俊奇.9c759226.jpg";